import { type HTMLAttributes } from "react"

import { type VariantProps, cva } from "class-variance-authority"

import { cn } from "@/lib/shadcn-utils"

const badgeVariants = cva(
  cn(
    "tw-inline-flex tw-items-center tw-h-6 tw-rounded-sm tw-shadow-sm",
    "tw-border tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold",
    "tw-transition-colors focus:tw-outline-none focus:tw-ring-2",
    "focus:tw-ring-ring focus:tw-ring-offset-0 tw-select-none",
  ),
  {
    variants: {
      variant: {
        default:
          "tw-border-transparent tw-bg-primary tw-text-primary-foreground hover:tw-bg-primary/80",
        secondary:
          "tw-border-transparent tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80",
        destructive:
          "tw-border-transparent tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive/80",
        outline: "tw-text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

export interface BadgeProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
